// Components - UI
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import PercentageCardContents from '@/components/ui/PercentageCardContents/PercentageCardContents.vue';
import Scroller from '@/components/ui/Scroller/Scroller.vue';

// Services
import ServiceProviderService from '@/services/ServiceProvidersService.js';
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';

// EventBus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'ServiceProviderDetail',

  components: {
    UserIcon,
    ReviewStars,
    Scroller
  },

  data: function() {
    return {
      userGroup: localStorage.getItem('userGroup'),
      serviceProvider: null,
      serviceRelationships: null,
      selectedServiceRelationship: null,
      serviceAreas: ServiceRelationshipsService.serviceAreas
    }
  },

  created: function() {

  },

  mounted: function() {
    this.init();
  },

  beforeDestroy: function() {

  },

  methods: {
    /**
      * @private
      */
    init: function(){
      this.loadServiceProvider();
      this.loadRelationships();
    },
    /**
      * @private
      */
    loadRelationships: function (){
      // Get the id from the params
      let id = this.$route.params.id;
      // Use the id to load the current service provider's relationships
      ServiceRelationshipsService.getAll({'serviceProvider':id})
      .then((res) => {
        console.log(res.data)
        this.serviceRelationships = res.data;
      });
    },

    /**
      * @private
      */
    loadServiceProvider: function (){
      // Get the id from the params
      let id = this.$route.params.id;
      // Use the id to load the current service provider
      ServiceProviderService.getById(id)
        .then((res) => {
          this.serviceProvider = res.data;
        });
    },

    getServiceArea: function(serviceAreaName) {
      return this.serviceAreas.find((item) => item.name == serviceAreaName);
    }
  },

  watch: {
    '$route' (to, from) {
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ServiceProviderDetail/ServiceProviderDetail.js